import { createSelector } from 'reselect';

const selectRateCards = (state: any) => state.rateCards;


export const selectRateCardCurrentItem = createSelector([selectRateCards], (rateCards) => rateCards.current);

export const selectRateCardsListItems = createSelector([selectRateCards], (rateCards) => rateCards.list);

export const selectRateCardItemById = (itemId: any) =>
    createSelector(selectRateCardsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectRateCardQueryItems = createSelector([selectRateCards], (rateCards) => rateCards.query);

export const selectRateCardCreatedItem = createSelector([selectRateCards], (rateCards) => rateCards.create);

export const selectRateCardUpdatedItem = createSelector([selectRateCards], (rateCards) => rateCards.update);

export const selectRateCardReadItem = createSelector([selectRateCards], (rateCards) => rateCards.read);

export const selectRateCardDeletedItem = createSelector([selectRateCards], (rateCards) => rateCards.delete);

export const selectRateCardSearchedItems = createSelector([selectRateCards], (rateCards) => rateCards.search);

export const selectRateCardItemsCount = createSelector([selectRateCards], (rateCards) => rateCards.count);

export const selectRateCardItemsFilter = createSelector([selectRateCards], (rateCards) => rateCards.filter);